/* global axios */
import ApiClient from './ApiClient';

class MarketingCampaignsAPI extends ApiClient {
  constructor() {
    super('marketing_campaigns', { accountScoped: true });
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  getNextCode(utmSource) {
    return axios.get(`${this.url}/next_code`, {
      params: { utm_source: utmSource },
    });
  }

  getReports(params) {
    return axios.get(`${this.url}/reports`, { params });
  }

  getContacts(params) {
    return axios.get(`${this.url}/contacts`, { params });
  }
}

export default new MarketingCampaignsAPI();
